import CardSquare from '@/common/components/cardSquare/CardSquare';
import { Link } from 'react-router-dom';
import ActionsIcon from '@/common/assets/icons/actions.svg?react';
import { ActionsCardProps } from '@/modules/FileDetail/components/entryTabs/Cards/ActionsCard/ActionsCard.types';
import { FILE_DETAIL_LINKS } from '@/modules/FileDetail/FileDetailLinks';
import { token } from 'styled-system/tokens';

const ActionsCard = ({ title }: ActionsCardProps) => {
  return (
    <Link to={FILE_DETAIL_LINKS.actions}>
      <CardSquare
        title={title}
        renderIcon={() => <ActionsIcon color={token('colors.orange')} />}
      />
    </Link>
  );
};
export default ActionsCard;
